const FormElementAlertStyle = {
  content: {
    textAlign: "center",
  }
}
export default FormElementAlertStyle;